export default __webpack_public_path__ + "static/media/ssApril@3x.6de6a7f3.png";